import type { FieldInputType, FieldType, TypeInstanceMap } from '@lighthouse/core'

export const silentInputTypes = new Set<FieldInputType>(['file', 'checkbox', 'slider'])

export const fieldSettingMap: Record<FieldInputType, FieldType[]> = {
    text: ['text', 'url', 'email', 'phoneNumber'],
    url: ['text', 'url', 'email', 'phoneNumber'],
    email: ['text', 'url', 'email', 'phoneNumber'],
    phoneNumber: ['text', 'url', 'email', 'phoneNumber'],
    // select: ['select'],
    relativeSelect: ['text', 'url', 'email', 'phoneNumber', 'select', 'number', 'role', 'singleSelect'],
    number: ['number'],
    date: ['date', 'text'],
    file: ['file', 'video'],
    notes: ['notes'],
    person: ['person'],
    checkbox: ['checkbox'],
    slider: ['number'],
    cascade: ['text', 'url', 'email', 'phoneNumber', 'department', 'parentDepartment'],
    calendar: ['date', 'text']
}

export const relativeSelectShowFieldList: FieldType[] = [
    'text',
    'url',
    'email',
    'phoneNumber',
    'date',
    'person',
    'id',
    'number',
    'aggregation',
    'formula'
]

export const PURE_TEXT_INPUT: FieldInputType[] = ['text', 'email', 'phoneNumber', 'url']

export const NO_FIELD_INPUT: FieldInputType[] = [
    'text',
    'email',
    'phoneNumber',
    'url',
    'slider',
    'checkbox',
    'date',
    'notes',
    'person',
    'number',
    'calendar'
]

export const RELATIVE_SELECT_FIELD_LIST: FieldType[] = ['id', 'text', 'url', 'phoneNumber', 'email', 'notes']

export const mathUserFieldList: FieldType[] = ['text', 'url', 'email', 'phoneNumber', 'notes', 'id', 'number']

export const multipleFieldInputList: FieldInputType[] = ['person']

export const fieldInputTypeList = new Set<FieldInputType>([
    'date',
    'email',
    'file',
    'notes',
    'number',
    'person',
    'phoneNumber',
    'relativeSelect',
    'text',
    // 'select',
    'url',
    'checkbox'
])

export const FieldTypeToInputTypeMap: Record<FieldType, FieldInputType | null> = {
    text: 'text',
    number: 'number',
    email: 'email',
    url: 'url',
    person: 'person',
    phoneNumber: 'phoneNumber',
    date: 'date',
    select: 'relativeSelect',
    file: 'file',
    notes: 'notes',
    checkbox: 'checkbox',
    aggregation: null,
    id: null,
    video: 'file',
    formula: null,
    role: 'relativeSelect',
    department: 'cascade',
    singleSelect: 'relativeSelect',
    parentDepartment: 'cascade',
    runtime: null
}

export const inputTypeToInnerTypeMap: Record<FieldInputType, TypeInstanceMap> = {
    text: 'TEXT',
    number: 'NUMBER',
    email: 'TEXT',
    url: 'TEXT',
    person: 'ARRAY',
    phoneNumber: 'TEXT',
    date: 'DATE',
    relativeSelect: 'TEXT',
    file: 'ARRAY',
    notes: 'RICH_TEXT',
    checkbox: 'BOOL',
    cascade: 'TEXT',
    slider: 'NUMBER',
    calendar: 'DATE'
}

export const inputTypeToFieldTypeMap: Record<FieldInputType, FieldType> = {
    text: 'text',
    number: 'number',
    email: 'email',
    url: 'url',
    person: 'person',
    phoneNumber: 'phoneNumber',
    date: 'date',
    relativeSelect: 'text',
    file: 'file',
    notes: 'notes',
    checkbox: 'checkbox',
    cascade: 'text',
    slider: 'number',
    calendar: 'date'
}

export const notNeedBlurInputTypes: Set<FieldInputType> = new Set([
    'person',
    'date',
    'relativeSelect',
    'file',
    'notes',
    'checkbox',
    'slider',
    'cascade',
    'calendar'
])
